module.exports = __webpack_public_path__ + "img/ja.57b1a6fc.jpg";